// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"56":"ce22086b","57":"e499a482","124":"b2579dfe","244":"8ebe553b","353":"ead56469","449":"87291b04","465":"2ccce8df","567":"3145ec26","660":"5e667519","697":"7dcc9f2d","712":"94f69f4c"}[chunkId] + ".chunk.js";
};